"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.durationToSeconds = exports.getThumbnail = void 0;

var _get = _interopRequireDefault(require("lodash/get"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var getThumbnail = function getThumbnail(videoDetails) {
  var thumbnails = (0, _get["default"])(videoDetails, 'snippet.thumbnails');
  var thumbnail = '';

  if (thumbnails) {
    var max = (0, _get["default"])(thumbnails, 'maxres.url');
    var high = (0, _get["default"])(thumbnails, 'high.url');
    var medium = (0, _get["default"])(thumbnails, 'medium.url');
    var standard = (0, _get["default"])(thumbnails, 'default.url');
    thumbnail = max || high || medium || standard;
  }

  return thumbnail;
};

exports.getThumbnail = getThumbnail;

var durationToSeconds = function durationToSeconds(duration) {
  var match = duration.match(/PT(\d+H)?(\d+M)?(\d+S)?/);
  match = match.slice(1).map(function (x) {
    if (x != null) {
      return x.replace(/\D/, '');
    }
  });
  var hours = parseInt(match[0]) || 0;
  var minutes = parseInt(match[1]) || 0;
  var seconds = parseInt(match[2]) || 0;
  return hours * 3600 + minutes * 60 + seconds;
};

exports.durationToSeconds = durationToSeconds;